import { render } from "./ProjectAnalysisTextItem.vue?vue&type=template&id=50de362c"
import script from "./ProjectAnalysisTextItem.vue?vue&type=script&lang=js"
export * from "./ProjectAnalysisTextItem.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__